import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-burger",
  "use": "icon-burger-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-burger\">\n    <title>A2DC1AD4-A4D1-4C14-9297-C2ACC3B1E744</title>\n    <g id=\"icon-burger_使用者視角－首頁\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-burger_1.0-Reborn-首頁-(320)\" transform=\"translate(-285.000000, -16.000000)\">\n            <g id=\"icon-burger_icon/menu\" transform=\"translate(285.000000, 16.000000)\">\n                <g>\n                    <rect id=\"icon-burger_Rectangle\" x=\"0\" y=\"0\" width=\"20\" height=\"20\" />\n                    <path d=\"M2,10.5 L18,10.5 M2,16.5 L18,16.5 M2,4.5 L18,4.5\" stroke=\"#000000\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/burger.svg
// module id = JYhB
// module chunks = 10